'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Flexbox = require('./Flexbox');

var _Flexbox2 = _interopRequireDefault(_Flexbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Flexbox2.default;


//////////////////
// WEBPACK FOOTER
// ./~/flexbox-react/dist/index.js
// module id = 129
// module chunks = 0